import React from 'react';

const TrackRecord = () => {
  return (
    <section className="track-record">
      <div className="track-record-container">
        <h2 className="track-record-title">
          Prior Experience
        </h2>
        
        <div className="track-record-description">
          Our leadership has managed multiple private real estate funds and dozens of single-tenant assets across the U.S. The figures below reflect prior funds and do not represent the current offering
        </div>

        <div className="track-record-stats">
          <div className="track-record-stat">
            <div className="track-record-number">5</div>
            <div className="track-record-label">Funds managed</div>
          </div>
          <div className="track-record-stat">
            <div className="track-record-number">70+</div>
            <div className="track-record-label">Properties</div>
          </div>
          <div className="track-record-stat">
            <div className="track-record-number">~20</div>
            <div className="track-record-label">States</div>
          </div>
          <div className="track-record-stat">
            <div className="track-record-number">~581k</div>
            <div className="track-record-label">Retail GLA</div>
          </div>
          <div className="track-record-stat">
            <div className="track-record-number">$175M+</div>
            <div className="track-record-label">AUM</div>
          </div>
        </div>

        <div className="track-record-disclaimer">
          For context only. Not part of the current fund. Past performance is not indicative of future results.
        </div>
      </div>
    </section>
  );
};

export default TrackRecord;


